package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_DELIVERY
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_FAVORITES
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_HOME
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_PROFILE
import com.example.mystybag.appCore.logic.NavigatorSelectPage
import com.example.mystybag.appCore.model.pages.ContactsUIState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.goToPhoneApp
import com.example.mystybag.core.expected.openInExternalBrowser
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.MainCallback

class ContactsViewModel(context: AppContext) : ChildViewModel<ContactsUIState>(
    context = context,
    uiData = ContactsUIState()
) {
    override fun onCreate() {
        navControls.backButtonVisible = true
        navControls.title = sharedString(SR.strings.contacts)
    }

    fun onEmailClicked() {
        openInExternalBrowser("mailto:${uiState.value.email}")
    }

    fun onPhoneClicked() {
        goToPhoneApp(uiState.value.phoneNumber)
    }

    fun onBackClick() {
        goBack()
    }
}
